import User from '@/models/user'

import { MessagesMutationTypes } from './messages'

export enum UserActionTypes {}

export enum UserMutationTypes {}

export interface State {
  userIds: number[]
  userEntities: { [id: number]: User }
}

const initialState: State = {
  userEntities: {},
  userIds: [],
}

export default {
  state: initialState,
  getters: {
    getUserById(state: State): (id: number) => User | null {
      return (id: number) => state.userEntities[id]
    },
  },
  actions: {},
  mutations: {
    [MessagesMutationTypes.LoadByBookingIdSuccess](
      state: State,
      normalizedMessages: any,
    ) {
      updateUsersFromMessage(state, normalizedMessages)
    },
    [MessagesMutationTypes.UpdateByBookingIdSuccess](
      state: State,
      normalizedMessages: any,
    ) {
      updateUsersFromMessage(state, normalizedMessages)
    },
  },
}

function updateUsersFromMessage(state: State, normalizedMessages: any) {
  const users = normalizedMessages.entities.users
  // TODO: refactor this later. This is a wrong usage of normalizr
  if (users) {
    Object.keys(users)
      .map(Number)
      .map((userId: number) => {
        state.userEntities = { ...state.userEntities, [userId]: users[userId] }
        if (state.userIds.indexOf(userId) < 0) {
          state.userIds = [...state.userIds, userId]
        }
      })
  }
}
